import cx from 'classnames';
import React from 'react';
import styled from 'styled-components/macro';

type Props = {
  long?: boolean;
  medium?: boolean;
  short?: boolean;
  thin?: boolean;
  thick?: boolean;
};

export const PlaceholderLine = (props: Props) => {
  const { long, medium, short, thin, thick } = props;
  const classes = { medium, long, thin, thick, short };
  return <Line className={cx('line', classes)} />;
};

export const Line = styled.div`
  width: 100%;
  height: 14px;
  display: block;

  &.long {
    width: 85%;
  }

  &.medium {
    width: 50%;
  }

  &.short {
    width: 35%;
  }

  &.thin {
    height: 8px;
  }

  &.thick {
    height: 30px;
  }
`;
